import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'
export const useCreateStyles = createStyleSheet((theme) => ({
  container: { flex: 1, backgroundColor: theme.COLOR_BG_BASE },
  body: { flex: 1 },
  content: { flex: 1, paddingHorizontal: rw(40), paddingTop: rh(32) },
  title: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(28), lineHeight: rf(32.2), letterSpacing: rw(-0.56) },
  description: { color: theme.COLOR_TEXT_SECONDARY, fontSize: rf(16), lineHeight: rf(22.4) },
  email: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(16), lineHeight: rf(22.4) },
  input: { color: theme.COLOR_TEXT_PRIMARY, padding: 0, fontSize: rf(20), lineHeight: rf(28), fontWeight: '500' },
  action: { paddingHorizontal: rw(24), paddingBottom: rh(24), paddingTop: rh(24) },
}))
